import React from "react";

import { IgButton, IgDialog } from "@intelligems/ig-theme";
import { useDialog } from "@src/hooks/dialog";

export const ConfirmDialog = () => {
  const dialog = useDialog("confirm");
  const {
    title = "Confirm",
    message,
    confirmText = "Ok",
    confirmAction,
    cancelText = "Cancel",
    cancelAction,
    tertiaryText,
    tertiaryAction,
    confirmColor,
    closeAction,
    showCloseIcon,
  } = dialog.props ?? {};

  const handleConfirm = () => {
    if (confirmAction) {
      confirmAction();
    }
    dialog.close();
  };

  const handleCancel = () => {
    if (cancelAction) {
      cancelAction();
    }
    dialog.close();
  };

  const handleTertiary = () => {
    if (tertiaryAction) {
      tertiaryAction();
    }
    dialog.close();
  };

  const handleClose = () => {
    if (closeAction) {
      closeAction();
    }
    dialog.close();
  };

  return (
    <IgDialog
      showDialog={dialog.isOpen}
      title={title}
      subtitle={message}
      handleClose={handleClose}
      showCloseIcon={showCloseIcon}
      yesButtonText={confirmText}
      handleYesClick={handleConfirm}
      noButtonText={cancelText}
      handleNoClick={handleCancel}
      yesButtonColor={confirmColor}
      dialogHeight={null}
      learnMoreButton={
        tertiaryText ? (
          <IgButton color={"link"} onClick={handleTertiary}>
            {tertiaryText}
          </IgButton>
        ) : undefined
      }
    />
  );
};
